import { create } from "zustand";

import { EventTiny } from "@/types/event";
import { PatientCreate } from "@/types/patient";

export enum CommandPaletteModal {
  CREATE_PATIENT = "create-patient",
  SEND_FORMS = "send-forms",
  CREATE_MEMO = "create-memo",
  CREATE_NOTE = "create-note",
  CREATE_TASK = "create-task",
  CREATE_OPPORTUNITY = "create-opportunity",
}

export interface CommandPaletteModalPrefill {
  createPatient?: Partial<PatientCreate>;
  createMemo?: { event?: EventTiny };
}

interface CommandPaletteModalsStore {
  activeModal: CommandPaletteModal | null;
  prefill: CommandPaletteModalPrefill;
  openModal: (
    modal: CommandPaletteModal,
    prefill?: CommandPaletteModalPrefill,
  ) => void;
  closeModal: () => void;
}

export const useCommandPaletteModalsStore = create<CommandPaletteModalsStore>(
  (set) => ({
    activeModal: null,
    prefill: {},
    openModal: (modal, prefill = {}) => set({ activeModal: modal, prefill }),
    closeModal: () => set({ activeModal: null, prefill: {} }),
  }),
);
